

<div class="stepper">
  <span class="active" > <mat-icon>check_circle</mat-icon> Add </span>
  <span> <mat-icon>check_circle</mat-icon> Select</span>
  <span> <mat-icon>check_circle</mat-icon> Prepare</span>
  <span> <mat-icon>check_circle</mat-icon> Review</span>
</div>








<!-- <mat-card class="menupannel">
    <button mat-flat-button (click)="openLeft()" > Participants<mat-icon>navigate_next</mat-icon></button>
    <button mat-icon-button [ngClass]="{'opened': openCenterPannel}" color="primary" (click)="openCenter()" > <mat-icon>expand_more</mat-icon></button>
    <button mat-flat-button (click)="openRight()" > <mat-icon>navigate_before</mat-icon> Tools </button>
</mat-card>
   -->
  
 <div class="step4">
  <div class="sign_holder">
    <div class="left_pannel" [ngClass]="{'open': openLeftPannel}" >
      <div class="esign">
        <mat-accordion>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Participants & Groups
              </mat-panel-title>
            </mat-expansion-panel-header>
  
            <div class="panel">
              <div class="search">
                <mat-form-field class="example-form-field">
                  <mat-label>Search and add participant </mat-label>
                  <input matInput type="text"  />

                  <button mat-button matSuffix mat-icon-button aria-label="Clear">
                    <mat-icon>search</mat-icon>
                  </button>
                </mat-form-field>
              </div>
  
              <div class="addparticipant">
                <h3>Participants Order</h3>
                <div class="addremove">
                  <button mat-icon-button color="primary">
                    <mat-icon>remove</mat-icon>
                  </button>
                  <button mat-icon-button color="primary">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
              </div>
  
              <div
                cdkDropList
                #todoList="cdkDropList"
                [cdkDropListData]="todo"
                [cdkDropListConnectedTo]="[doneList]"
                class="group1"
                (cdkDropListDropped)="drop($event)"
              >
                <h2>Group 1</h2>
                <div class="moveblock" *ngFor="let item of todo" cdkDrag>
                  <span><mat-checkbox color="{{item.color}}" ></mat-checkbox>
                    {{ item.role }}</span>
  
                  <span class="text-grey">
                    <button mat-icon-button >
                      <mat-icon>person_add_alt_1</mat-icon>
                    </button>
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  </span>
                </div>
              </div>
              <mat-menu #menu="matMenu" xPosition="before">
                <button mat-menu-item>Assign</button>
                <button mat-menu-item>Unassign</button>
                <button mat-menu-item>Delete</button>
              </mat-menu>
  
              <div class="group1 final">
                <h2>Send Final Copy</h2>
  
                <div
                  cdkDropList
                  #doneList="cdkDropList"
                  [cdkDropListData]="done"
                  [cdkDropListConnectedTo]="[todoList]"
                  class="getfinal"
                  (cdkDropListDropped)="drop($event)">
  
                  <div class="moveblock" *ngFor="let item of done" cdkDrag>
                      <span><mat-checkbox color="{{item.color}}" ></mat-checkbox>
                          {{item.role}}</span>
  
                    <span class="text-grey">
                      <button mat-icon-button >
                        <mat-icon>person_add_alt_1</mat-icon>
                      </button>
                      <button mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
  
  
              <div class="group1 mt-10">
                  <h2>Non-Participant </h2>
    
                  <div
                    cdkDropList
                    #doneList="cdkDropList"
                    [cdkDropListData]="done"
                    [cdkDropListConnectedTo]="[todoList]"
                    class="getfinal"
                    (cdkDropListDropped)="drop($event)">
    
                  </div>
                </div>
  
            </div>
          </mat-expansion-panel>
  
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Fillable Fields
              </mat-panel-title>
            </mat-expansion-panel-header>
            <button mat-icon-button (click)="createNewFilled()" class="addFolder" color="primary"  >
              <mat-icon>add</mat-icon>
            </button>
  
            <div class="fillablefields">
              <mat-accordion>
              
                  <mat-expansion-panel [expanded]="false">
                    
                      <mat-expansion-panel-header>
                      <mat-panel-title>
                       <div class="foldername">
                          <mat-icon>folder</mat-icon> Employee                   
                       </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <button mat-icon-button (click)="createNewFilled()" class="addFill" color="primary"  >
                      <mat-icon>add</mat-icon>
                    </button>
                    <div class="panel">
                          <div class="listpanel" *ngFor="let field of fillablefiled" >
                            <mat-icon>drag_indicator</mat-icon> {{field}}
                          </div>
                    </div>
                    
                  </mat-expansion-panel>
      
                  <mat-expansion-panel [expanded]="false">
                    
                      <mat-expansion-panel-header>
                      <mat-panel-title>
                       <div class="foldername">
                          <mat-icon>folder</mat-icon> Facility
                       </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <button mat-icon-button class="addFill" color="primary"  >
                      <mat-icon>add</mat-icon>
                    </button>
                    <div class="panel">
                          <div class="listpanel" *ngFor="let field of fillablefiled" >
                            <mat-icon>drag_indicator</mat-icon> {{field}}
                          </div>
                    </div>
                    
                  </mat-expansion-panel>
              
                </mat-accordion>
            </div>
  
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
    <div class="overlayLeft" (click)="openLeft()"  [ngClass]="{'open': openLeftPannel}" ></div>
  
  
    <div class="centerpanel">
  
      <mat-card class="header" [ngClass]="{'open': openCenterPannel }" >
       
  
          <div class="uploadoc">
              <button mat-button (click)="addformdoc()" >Add Forms & Documents <mat-icon>expand_more</mat-icon></button>
              <div class="addDocument" [ngClass]="{'active':addDocument }" >
                <ul>
                  <li>Upload File <mat-icon>add</mat-icon></li>
                  <li>Existing Documents <mat-icon>add</mat-icon></li>
                  <li>Existing Documents <mat-icon>add</mat-icon></li>
                  <li>Existing Template <mat-icon>add</mat-icon></li>
                  <li>Existing Form <mat-icon>add</mat-icon></li>
                  <li>Empty Form <mat-icon>add</mat-icon></li>
                </ul>
              </div>
          </div>
          
          <div class="doctools">
            <div class="tools">
              <div class="tool"><mat-icon>save</mat-icon></div>
              <div class="tool"><mat-icon>undo</mat-icon></div>
              <div class="tool"><mat-icon>redo</mat-icon></div>
              <div class="tool"><mat-icon [matMenuTriggerFor]="appMenu" >more_vertical</mat-icon></div>
            </div>
          </div>
  
          <div class="actbut">
            <button mat-stroked-button color="primary">Preview</button>
            <button mat-flat-button color="primary">Send</button>
          </div>
          
    
  
        </mat-card>
  
      <mat-menu #appMenu="matMenu" xPosition="before">
        <button mat-menu-item>Rename</button>
        <button mat-menu-item>Save as template</button>
        <button mat-menu-item>Save as project</button>
      </mat-menu>
    </div>
  
  
    <div class="right_pannel" [ngClass]="{'open': openRightPannel}" >
      <div class="esign">
        <mat-accordion>
          <mat-expansion-panel >
            <mat-expansion-panel-header>
              <mat-panel-title>
               Tools
              </mat-panel-title>
            </mat-expansion-panel-header>
  
            <div class="panel">
  
              <div class="tools">
                <div class="tool"><img src="../../../assets/images/tool/align.svg" alt="Align Above"></div>
                <div class="tool"><img src="../../../assets/images/tool/center.svg" alt="Vertical middle"></div>
                <div class="tool below"><img src="../../../assets/images/tool/align.svg" alt="Align Above"></div>
              
                <div class="tool leftAlign"><img src="../../../assets/images/tool/align.svg" alt="Align Above"></div>
                <div class="tool horizentalCenter"><img src="../../../assets/images/tool/center.svg" alt="Vertical middle"></div>
                <div class="tool rightAlign"><img src="../../../assets/images/tool/align.svg" alt="Align Above"></div>
              </div>
  
              <div class="tools">
  
                <div class="alignment">
                  <div class="tool"><img src="../../../assets/images/tool/left.svg"></div>
                  <div class="tool"><img src="../../../assets/images/tool/text-center.svg"></div>
                  <div class="tool"><img src="../../../assets/images/tool/right.svg"></div>
                  <div class="tool"><img src="../../../assets/images/tool/justify.svg"></div>
                </div>
  
                <div class="tool "><img src="../../../assets/images/tool/mask.svg" alt="Vertical middle"></div>
                <div class="tool "><img src="../../../assets/images/tool/calculator.svg" alt="Align Above"></div>
              </div>
              <div class="tools">
                <div class="tool"><img src="../../../assets/images/tool/Capitalize.svg" alt="Align Above"></div>
                <div class="tool"><img src="../../../assets/images/tool/underline.svg" alt="Vertical middle"></div>
                <div class="tool "><img src="../../../assets/images/tool/dollar.svg" alt="Align Above"></div>
              
                <div class="tool "><img src="../../../assets/images/tool/decimal.svg" alt="Align Above"></div>
                <div class="tool "><img src="../../../assets/images/tool/link.svg" alt="Vertical middle"></div>
                <div class="tool "><img src="../../../assets/images/tool/eye.svg" alt="Align Above"></div>
              </div>
  
              <div class="tools">
                <div class="tool"><img src="../../../assets/images/tool/require.svg" alt="Align Above"></div>
                <div class="tool delete"><img src="../../../assets/images/tool/delete.svg" alt="Vertical middle"></div>
              </div>
  
            </div>
          </mat-expansion-panel>
  
  
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Form Tools
              </mat-panel-title>
            </mat-expansion-panel-header>
  
            <div class="panel">
  
              <div class="ftool">
                <div class="tool" >
                  <mat-icon>drag_indicator</mat-icon> 
                  <span> <mat-icon>power_input</mat-icon>Single-Line</span>
                </div>
                <div class="tool" >
                  <mat-icon>drag_indicator</mat-icon> 
                  <span> <mat-icon>dehaze</mat-icon>Multi-Line</span>
                </div>
                  <div class="tool" >
                    <mat-icon>drag_indicator</mat-icon> 
                    <span> <mat-icon>check_box</mat-icon> Check Box</span>
                  </div>
                  <div class="tool" >
                    <mat-icon>drag_indicator</mat-icon> 
                    <span> <mat-icon>radio_button_checked</mat-icon>Radio</span>
                  </div>
                  <div class="tool" >
                    <mat-icon>drag_indicator</mat-icon> 
                    <span> <mat-icon>filter_1</mat-icon>Number</span>
                  </div>
                   
                  <div class="tool" >
                    <mat-icon>drag_indicator</mat-icon> 
                    <span> <mat-icon>event_available</mat-icon>Date</span>
                  </div>
                  <div class="tool" >
                    <mat-icon>drag_indicator</mat-icon> 
                    <span> <mat-icon>arrow_drop_down_circle</mat-icon>Dropdown</span>
                  </div>
                  <div class="tool" >
                    <mat-icon>drag_indicator</mat-icon> 
                    <span> <mat-icon>wallpaper</mat-icon>Image</span>
                  </div>
                  <div class="tool" >
                    <mat-icon>drag_indicator</mat-icon> 
                    <span> <mat-icon>done</mat-icon> Approval</span>
                  </div>
                  <div class="tool" >
                    <mat-icon>drag_indicator</mat-icon> 
                    <span> <mat-icon>highlight_alt</mat-icon>Initials</span>
                  </div>
                  <div class="tool" >
                    <mat-icon>drag_indicator</mat-icon> 
                    <span> <mat-icon>gesture</mat-icon>Signature</span>
                  </div>
                  <div class="tool" >
                    <mat-icon>drag_indicator</mat-icon> 
                    <span> <mat-icon>strikethrough_s</mat-icon>Strike Through</span>
                  </div>
                  
                  <div class="tool" >
                    <mat-icon>drag_indicator</mat-icon> 
                    <span> <mat-icon>done</mat-icon>White Out</span>
                  </div>
                  <div class="tool" >
                    <mat-icon>drag_indicator</mat-icon> 
                    <span> <mat-icon>insert_drive_file</mat-icon>File</span>
                  </div>
                 
                  <div class="tool" >
                    <mat-icon>drag_indicator</mat-icon> 
                    <span> <mat-icon>brush</mat-icon>Draw</span>
                  </div>
              </div>
  
            </div>
          </mat-expansion-panel>
      
  
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Forms & Documents
              </mat-panel-title>
            </mat-expansion-panel-header>
  
            <div class="panel">
  
              <div class="forms">
                  <div class="file">
                    <span>Employee Withholding Allowance Certificate-3</span>
                    <mat-icon>more_vertical</mat-icon>
                  </div>
                  
                  <div class="file">
                    <span>NTC Tax Credit Qualification Form-5</span>
                    <mat-icon>more_vertical</mat-icon>
                  </div>
  
              </div>
  
            </div>
          </mat-expansion-panel>
  
        </mat-accordion>
      </div>
    </div>
    <div class="overlayRight" (click)="openRight()" [ngClass]="{'open': openRightPannel}"   ></div>
  </div>
  
 </div>











  <app-create-fillable-fields (closeCreate)="getCreateClose($event)" [ngClass]="{'open': createFilled}" ></app-create-fillable-fields> 